import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-northmill',
  templateUrl: './link-northmill.component.html',
  styleUrls: ['./link-northmill.component.scss'],
})
export class LinkNorthmillComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;
  @Output() next = new EventEmitter();
  public busy = true;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('NORTHMILL_CHANNEL');
  public win;
  public configurationSaved: boolean = false;
  public username: string = null;
  public password: string = null;

  //VERY COOL LINK
  //https://stackoverflow.com/questions/28230845/communication-between-tabs-or-windows

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.busy = false;
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        Username: this.username,
        Password: this.password,
        POSID: 11,
      })
      .subscribe((x) => {
        if (this.modal !== undefined) this.modal.dismiss('Cross click');
        else this.next.emit();
      });
  }

  done() {
    this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }
}
